import {Mark, mergeAttributes} from '@tiptap/core';

export default Mark.create({
    name: 'customButton',

    addAttributes() {
        return {
            href: {
                default: null,
            },
            class: {
                default: 'v-btn',
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'button[href]',
            },
        ];
    },

    renderHTML({HTMLAttributes}) {
        return ['button', mergeAttributes(HTMLAttributes), 0];
    },

    addCommands() {
        return {
            setButton:
                (options) =>
                ({commands}) => {
                    return commands.setMark(this.name, options);
                },
            toggleButton:
                (options) =>
                ({commands}) => {
                    return commands.toggleMark(this.name, options);
                },
            unsetButton:
                () =>
                ({commands}) => {
                    return commands.unsetMark(this.name);
                },
        };
    },
});
